import type { LangFn } from './localization';

const CODE_LANGUAGE_ALIASES: Record<string, string[]> = {
  '1c': ['1с'], // Allow cyrillic
  ada: [],
  arduino: ['ino'],
  armasm: ['arm'],
  bash: ['sh'],
  basic: [],
  c: ['h'],
  cpp: ['cc', 'c++', 'h++', 'hpp', 'hh', 'hxx', 'cxx'],
  csharp: ['cs', 'c#'],
  css: [],
  dart: [],
  dockerfile: ['docker'],
  erlang: ['erl'],
  elixir: ['ex', 'exs'],
  go: ['golang'],
  handlebars: ['hbs', 'html.hbs', 'html.handlebars', 'htmlbars'],
  haskell: ['hs'],
  ini: ['toml'],
  java: ['jsp'],
  javascript: ['js', 'jsx', 'mjs', 'cjs', 'mjsx', 'cjsx'],
  json: [],
  kotlin: ['kt', 'kts'],
  latex: ['tex'],
  lisp: [],
  lua: [],
  makefile: ['mk', 'mak', 'make'],
  markdown: ['md', 'mkdown', 'mkd'],
  matlab: [],
  nginx: ['nginxconf'],
  objectivec: ['mm', 'objc', 'obj-c', 'obj-c++', 'objective-c++'],
  perl: ['pl', 'pm'],
  php: [],
  powershell: ['ps1', 'ps'],
  python: ['py', 'gyp', 'ipython'],
  r: [],
  ruby: ['rb', 'gemspec', 'podspec', 'thor', 'irb'],
  rust: ['rs'],
  scheme: [],
  scss: [],
  shell: [],
  smalltalk: ['st'],
  sql: [],
  swift: [],
  plaintext: ['text', 'plain', 'txt'],
  twig: ['craftcms'],
  typelanguage: ['tl'],
  typescript: ['ts', 'tsx', 'mts', 'cts', 'mtsx', 'ctsx'],
  xml: ['html', 'xhtml', 'rss', 'atom', 'xjb', 'xsd', 'xsl', 'plist', 'wsf', 'svg'],
  yaml: [],
};

const PRETTY_LANGUAGE_NAMES: Record<string, string | undefined> = {
  '1c': '1C',
  ada: 'Ada',
  arduino: 'Arduino',
  armasm: 'ARM Assembly',
  bash: 'Bash',
  basic: 'BASIC',
  c: 'C',
  cpp: 'C++',
  csharp: 'C#',
  css: 'CSS',
  dart: 'Dart',
  dockerfile: 'Dockerfile',
  elixir: 'Elixir',
  erlang: 'Erlang',
  go: 'Go',
  handlebars: 'Handlebars',
  haskell: 'Haskell',
  ini: 'INI',
  java: 'Java',
  javascript: 'JavaScript',
  json: 'JSON',
  kotlin: 'Kotlin',
  latex: 'LaTeX',
  lisp: 'Lisp',
  lua: 'Lua',
  makefile: 'Makefile',
  markdown: 'Markdown',
  matlab: 'MATLAB',
  nginx: 'Nginx',
  objectivec: 'Objective-C',
  perl: 'Perl',
  php: 'PHP',
  powershell: 'PowerShell',
  python: 'Python',
  r: 'R',
  ruby: 'Ruby',
  rust: 'Rust',
  scheme: 'Scheme',
  scss: 'SCSS',
  shell: 'Shell',
  smalltalk: 'Smalltalk',
  sql: 'SQL',
  swift: 'Swift',
  twig: 'Twig',
  typelanguage: 'TL',
  typescript: 'TypeScript',
  xml: 'XML',
  yaml: 'YAML',
};

export const SUPPORTED_CODE_LANGUAGES = Object.keys(CODE_LANGUAGE_ALIASES);

export function getPrettyCodeLanguageName(lang: LangFn, codeLanguage: string) {
  const languageName = getCodeLanguageName(codeLanguage.toLowerCase()) || codeLanguage;
  if (languageName === 'plaintext') return lang('CodeLanguagePlainText');
  return PRETTY_LANGUAGE_NAMES[languageName] ?? languageName;
}

export function getCodeLanguageName(alias: string) {
  return Object.entries(CODE_LANGUAGE_ALIASES)
    .find(([langName, aliases]) => langName === alias || aliases.includes(alias))?.[0];
}
